import { symbol } from "./symbol.js";
<ebay-icon ...input _name="chevron-right-16" _size="16" _type="icon" _themes=symbol/>